import React from "react";
import {css, Theme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {borderRadius, display, mb, mr, onDesktop, p, truncateMultiline} from "@pg-design/helpers-css";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";
import {ARTICLE_TEST_IDS} from "@pg-mono/e2e-test-utils";
import {rpAppLink} from "@pg-mono/rp-routes";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";

interface IProps {
    className?: string;
    articleTitle: React.JSX.Element;
    imageLoading?: HTMLImageElement["loading"];
    article: {
        author: {
            name: string;
        };
        date_published: string | null;
        gallery: (
            | {
                  image: {
                      g_img_65x65: string;
                      g_img_206x206: string;
                      g_img_349x239: string;
                  };
              }
            | undefined
        )[];
        id: number;
        lead: string | null;
        slug: string;
        title: string;
    };
}

export const ArticleListBoxWide = (props: IProps) => {
    const {article} = props;
    const articleLink = rpAppLink.article.detail({
        articleSlug: article.slug,
        articleId: article.id
    });
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const articleBoxHandler = (event: React.MouseEvent<HTMLDivElement>) => {
        const linkElement = event.currentTarget.querySelector("a");

        if (linkElement && linkElement.contains(event.target as Node)) {
            return;
        }
        event.stopPropagation();
        window.open(articleLink, responsiveLinkTarget);
    };
    return (
        <div className={props.className} css={articleListBox} onClick={articleBoxHandler} data-testid={ARTICLE_TEST_IDS.ARTICLE_LIST.ARTICLE_BOX}>
            {article.gallery[0]?.image && (
                <Picture
                    css={picture}
                    sources={[
                        {minWidthPX: 0, src: article.gallery[0].image.g_img_206x206, width: 206, height: 206},
                        {minWidthPX: 1200, src: article.gallery[0].image.g_img_349x239, width: 332, height: 208}
                    ]}
                    alt={article.title}
                    loading={props.imageLoading}
                />
            )}

            <div css={[p(1), onDesktop(p(2))]}>
                <Text css={mb(2)} as="div" variant="info_txt_2">
                    <div css={[display("inline-block"), mr(3)]}>{formatDate(article.date_published, dateTimeFormat.shortDate)}</div>
                    <div css={[display("inline-block")]}>{article.author.name}</div>
                </Text>
                <a css={link} href={articleLink} target={responsiveLinkTarget} data-testid={ARTICLE_TEST_IDS.ARTICLE_LIST.ARTICLE_BOX}>
                    {props.articleTitle}
                </a>

                <Text css={[display("none"), onDesktop(display("block"))]} variant="body_copy_1">
                    {article.lead}
                </Text>
            </div>
        </div>
    );
};

export const articleListBox = (theme: Theme) => css`
    display: flex;
    flex-direction: row;
    overflow: hidden;
    ${elevation(2)};
    ${borderRadius(2)}
    background-color: #fff;

    &:hover {
        color: ${theme.colors.secondary};
        text-decoration: none;
        cursor: pointer;
    }
`;

const link = (theme: Theme) => css`
    &:visited,
    &:hover,
    &:focus,
    &:active {
        color: ${theme.colors.secondary};
        text-decoration: none;
    }
`;

const picture = css`
    flex-shrink: 0;
    max-width: 160px;

    ${onDesktop(css`
        max-width: 349px;
        max-height: 239px;
    `)}
`;

export const articleListBoxTitle = (theme: Theme) => css`
    font-size: 1.519rem;
    @media (max-width: ${theme.breakpoints.md}) {
        ${truncateMultiline(3)};
    }
    @media (min-width: ${theme.breakpoints.md}) {
        font-size: 2.243rem;
        ${mb(2)};
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {borderRadius, display, mb, mr, onDesktop, p, truncateMultiline} from "@pg-design/helpers-css";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";
import {ARTICLE_TEST_IDS} from "@pg-mono/e2e-test-utils";
import {rpAppLink} from "@pg-mono/rp-routes";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";

interface IProps {
    className?: string;
    articleTitle: React.JSX.Element;
    imageLoading?: HTMLImageElement["loading"];
    article: {
        author: {
            name: string;
        };
        date_published: string | null;
        gallery: (
            | {
                  image: {
                      g_img_65x65: string;
                      g_img_206x206: string;
                      g_img_349x239: string;
                  };
              }
            | undefined
        )[];
        id: number;
        lead: string | null;
        slug: string;
        title: string;
    };
}

export const ArticleListBoxWide = (props: IProps) => {
    const {article} = props;
    const articleLink = rpAppLink.article.detail({
        articleSlug: article.slug,
        articleId: article.id
    });
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const articleBoxHandler = (event: React.MouseEvent<HTMLDivElement>) => {
        const linkElement = event.currentTarget.querySelector("a");

        if (linkElement && linkElement.contains(event.target as Node)) {
            return;
        }
        event.stopPropagation();
        window.open(articleLink, responsiveLinkTarget);
    };
    return (
        <div className={props.className} css={articleListBox} onClick={articleBoxHandler} data-testid={ARTICLE_TEST_IDS.ARTICLE_LIST.ARTICLE_BOX}>
            {article.gallery[0]?.image && (
                <Picture
                    css={picture}
                    sources={[
                        {minWidthPX: 0, src: article.gallery[0].image.g_img_206x206, width: 206, height: 206},
                        {minWidthPX: 1200, src: article.gallery[0].image.g_img_349x239, width: 332, height: 208}
                    ]}
                    alt={article.title}
                    loading={props.imageLoading}
                />
            )}

            <div css={[p(1), onDesktop(p(2))]}>
                <Text css={mb(2)} as="div" variant="info_txt_2">
                    <div css={[display("inline-block"), mr(3)]}>{formatDate(article.date_published, dateTimeFormat.shortDate)}</div>
                    <div css={[display("inline-block")]}>{article.author.name}</div>
                </Text>
                <a css={link} href={articleLink} target={responsiveLinkTarget} data-testid={ARTICLE_TEST_IDS.ARTICLE_LIST.ARTICLE_BOX}>
                    {props.articleTitle}
                </a>

                <Text css={[display("none"), onDesktop(display("block"))]} variant="body_copy_1">
                    {article.lead}
                </Text>
            </div>
        </div>
    );
};

export const articleListBox = (theme: Theme) => css`
    display: flex;
    flex-direction: row;
    overflow: hidden;
    ${elevation(2)};
    ${borderRadius(2)}
    background-color: #fff;

    &:hover {
        color: ${theme.colors.secondary};
        text-decoration: none;
        cursor: pointer;
    }
`;

const link = (theme: Theme) => css`
    &:visited,
    &:hover,
    &:focus,
    &:active {
        color: ${theme.colors.secondary};
        text-decoration: none;
    }
`;

const picture = css`
    flex-shrink: 0;
    max-width: 160px;

    ${onDesktop(css`
        max-width: 349px;
        max-height: 239px;
    `)}
`;

export const articleListBoxTitle = (theme: Theme) => css`
    font-size: 1.519rem;
    @media (max-width: ${theme.breakpoints.md}) {
        ${truncateMultiline(3)};
    }
    @media (min-width: ${theme.breakpoints.md}) {
        font-size: 2.243rem;
        ${mb(2)};
    }
`;
